export enum POVType {
    DATA = 'DATA',
    LOCKED = 'LOCKED',
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
    FREE = 'FREE',
}
